import { useParams } from "react-router-dom";
import { serviceData } from "../../../data/order/serviceData";
import { CompanyLogo } from "../../../assets/Order";
import { ServiceInvoiceData } from "../../../data/order/serviceInvoiceData";

export default function Invoice()
{
const { id } = useParams();

  const order = serviceData.find((o) => o.id === id);

  if (!order) {
    return (
      <div className="p-4 text-red-600 text-center font-semibold">
        Order not found for ID: {id}
      </div>
    );
  }

const invoice = ServiceInvoiceData.find((i) => i.serviceId === order.id);
const totalAmount = invoice.issues.reduce(
  (sum, item) => sum + item.qty * item.price,
  0
);

const discount = (totalAmount * invoice.discountpercent) / 100;
const payableAmount = totalAmount - discount;

  if (!invoice) {
    return (
      <div className="p-4 text-red-600 text-center font-semibold">
        Invoice not found for order ID: {id}
      </div>
    );
  }

    return(
        <section className="px-5 py-1" id="service-invoice">
             <div className="grid grid-cols-2 pb-5 border-b-2 border-gray-500">
                <div className="flex flex-col justify-between">
                    <img src={CompanyLogo} className="w-60 h-20"/>
                    <p className="text-4xl font-semibold">Invoice</p>
                </div>
                <div className="flex flex-col space-y-1 justify-start items-end">
                    <p className="text-xl font-medium text-left">Asia Link Computers</p>
                    <p>Shop No.-11, 1577,</p>
                    <p>BhagyaNagari Society,</p>
                    <p>Tilak Road, Sadashiv Peth,</p>
                    <p>Pune - 411030</p>
                    <p>(Near Baba Computer, Opposite Maharashtra Mandal)</p>
                </div>
             </div>

             <div className="grid grid-cols-2 py-5 border-b-2 border-gray-500">
                <div className="">
                    <p className="font-medium text-xl">Bill to:</p>
                    <p>{invoice.billTo.name}</p>
                    <p>{invoice.billTo.flatNo}</p>
                    <p>{invoice.billTo.societyname}</p>
                    <p>{invoice.billTo.city}</p>
                    <p>{invoice.billTo.pincode}</p>
                </div>
                <div className="flex flex-col space-y-1">
                    <div>
                    <p className="font-medium text-end">Invoice Number</p>
                    <p className="text-end">{invoice.invoiceNo}</p>
                    </div>
                    <div>
                    <p className="font-medium text-end">Invoice Date</p>
                    <p className="text-end">{invoice.InvoiceDate}</p>
                    </div>
                    <div>
                    <p className="font-medium text-end">GSTIN Code</p>
                    <p className="text-end">{invoice.gstin}</p>
                    </div>

                </div>
             </div>

              <div className="py-5 border-b-2 border-gray-500">
                <table className="w-full text-left border border-zinc-300 mb-2 rounded">
  <thead className="bg-gray-100 border-b border-zinc-300">
    <tr>
      <th className="p-2 pb-4">Device</th>
      <th className="p-2 pb-4">Serial number</th>
      <th className="p-2 pb-4">Issue name</th>
      <th className="p-2 pb-4">Qty</th>
      <th className="p-2 pb-4">Unit Price</th>
      <th className="p-2 pb-4">Total</th>
    </tr>
  </thead>
  <tbody>
    {invoice.issues.map((item, i) => (
      <tr key={i} className="border-b border-zinc-300">
        {i === 0 && (
          <>
            <td className="p-2 pb-4 border-r border-zinc-300 text-center" rowSpan={invoice.issues.length}>
              {invoice.productName}
            </td>
            <td className="p-2 pb-4 border-r border-zinc-300 text-center" rowSpan={invoice.issues.length}>
              {invoice.serialNumber}
            </td>
          </>
        )}
        <td className="p-2 pb-4">{item.name}</td>
        <td className="p-2 pb-4">{item.qty}</td>
        <td className="p-2 pb-4">₹ {item.price}</td>
        <td className="p-2 pb-4">₹ {item.qty * item.price}</td>
      </tr>
    ))}
  </tbody>
</table>

              </div>

              <div className="py-5 grid grid-cols-2">
                <div></div>

                <div className="grid grid-cols-2 space-y-1 pl-10">
                  <p className="font-medium">Total no. of services :</p>
                  <p className="text-right">{invoice.issues.length}</p>
                  <p className="font-medium">Total amount :</p>
                  <p className="text-right">+  ₹ {totalAmount.toFixed(2)}</p>
                  <p className="font-medium">Discount:</p>
                  <p className="text-right">-  ₹ {discount.toFixed(2)}</p>
                  <hr className="col-span-2 border-t-2"/>
                  <p className="font-medium">Payable Amount:</p>
                  <p className="text-right">₹ {payableAmount.toFixed(2)}</p>
                </div>
              </div>

              <div className=" flex flex-col mt-4">
                <div className="flex flex-row space-x-1 items-center">
                    <p className="font-medium">Notes :</p>
                    <p>Mention "Repaired items shipped as part of service."</p>
                </div>
                <div className="flex flex-row space-x-1 items-center">
                    <p className="font-medium">Declaration :</p>
                    <p>"This is a computer-generated invoice and does not require a signature."</p>
                </div>
                <div className="flex flex-row space-x-1 items-center">
                    <p className="font-medium">Bank details</p>
                    <p>(if applicable).</p>
                </div>
              </div>
        </section>
    );
}